import { RouteNotFoundPage } from '@app/components/errors/RouteNotFoundPage';
import { AppRoute } from '@app/core/routing/AppRoute';
import { AdminGroupsRoutes } from '@app/modules/admin/screens/groups/AdminGroupsRoutes';
import { AdminStationGroupsRoutes } from '@app/modules/admin/screens/station-groups/AdminStationGroupsRoutes';
import { AdminStationsRoutes } from '@app/modules/admin/screens/stations/AdminStationsRoutes';
import { AdminUsersRoutes } from '@app/modules/admin/screens/users/AdminUsersRoutes';
import { YoutubeRoutes } from '@app/modules/youtube/routing/YoutubeRoutes';
import { UserRole } from '@mi-front/core';
import { Redirect, Route, Switch } from 'react-router-dom';
import { AdminShell } from '../navigation/AdminShell';
import { AlertsRoutes } from '../screens/alerts/AlertsRoutes';
import { AdminAuditRoutes } from '../screens/audit/AdminAuditRoutes';
import { AdminContentAiRoutes } from '../screens/content-ai/AdminContentAiRoutes';
import { AdminFragmentsRoutes } from '../screens/fragments/AdminFragmentsRoutes';
import { AdminSocialExportRoutes } from '../screens/social-export/AdminSocialExportRoutes';
import { AdminVideoAnalysisRoutes } from '../screens/video-analysis/AdminVideoAnalysisRoutes';

export function AdminRoutes() {
  return (
    <Route path="/admin">
      <AdminShell>
        <Switch>
          <AppRoute
            allowedRole={UserRole.CLIENT_ADMIN}
            path={`/admin/station-groups`}
            component={AdminStationGroupsRoutes}
          />
          <AppRoute
            allowedRole={UserRole.CLIENT_ADMIN}
            path={`/admin/stations`}
            component={AdminStationsRoutes}
          />
          <AppRoute
            allowedRole={UserRole.CLIENT_ADMIN}
            path={`/admin/users`}
            component={AdminUsersRoutes}
          />
          <AppRoute
            allowedRole={UserRole.CLIENT_ADMIN}
            path={`/admin/groups`}
            component={AdminGroupsRoutes}
          />
          <AppRoute
            allowedRole={UserRole.CLIENT_ADMIN}
            path={`/admin/alerts`}
            component={AlertsRoutes}
          />
          <AppRoute
            allowedRole={UserRole.CLIENT_ADMIN}
            path={`/admin/social-export`}
            component={AdminSocialExportRoutes}
          />
          <AppRoute
            allowedRole={UserRole.CLIENT_ADMIN}
            path={`/admin/youtube`}
            component={YoutubeRoutes}
          />
          <AppRoute
            allowedRole={UserRole.CLIENT_ADMIN}
            path={`/admin/fragments`}
            component={AdminFragmentsRoutes}
          />
          <AppRoute
            allowedRole={UserRole.CLIENT_ADMIN}
            path={`/admin/content-ai`}
            component={AdminContentAiRoutes}
          />
          <AppRoute
            allowedRole={UserRole.CLIENT_ADMIN}
            path={`/admin/video-analysis`}
            component={AdminVideoAnalysisRoutes}
          />
          <AppRoute
            allowedRole={UserRole.CLIENT_ADMIN}
            path={`/admin/audit`}
            component={AdminAuditRoutes}
          />
          <Redirect exact from="/admin" to="/admin/stations" />
          <Route component={RouteNotFoundPage} />
        </Switch>
      </AdminShell>
    </Route>
  );
}
